require("core-js/modules/es.array.reduce.js");

exports.reduce = require('rxjs/internal/operators/reduce').reduce;